module.exports = __webpack_public_path__ + "static/catalogue1-52554790361be1edb3ba4b7a1410664a.png";